<div class="grid-container padding-y-4">
  <div class="grid-row">
    <legend class="usa-legend usa-legend--large">FRT TSP Performance Metrics</legend>
  </div>
  <form id="frtTspRatingFormGroup" role="form" [formGroup]="frtTspRatingFormGroup" (ngSubmit)="getFrtTspRating()">
    <div class="grid-row">
      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
        <label for="reportingYrSelect" class="usa-label">Reporting Calender Year<abbr title="required"
        class="usa-hint usa-hint--required">*</abbr></label>
        <select id="reportingYrSelect" class="usa-select width-full" formControlName='reportingYrSelect' (change)="getFrtTspRating();">
          <option hidden value=''>Choose...</option>
          @for (year of years; track year) {
            <option [value]="year.value">
            {{year.name}}</option>
          }
        </select>
      </div>
    </div>
    <div class="grid-row grid-gap margin-top-2">
      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
        <img src="assets/uswds/img/usa-icons/file_download.svg" alt="user_icon"> Right click on the report and select the appropriate options to export.
      </div>
      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
        Ovreall Rating (1 star - Poor, 2 stars - Fair, 3 stars - Good, 4 stars - Very Good, 5 stars - Excellent)
      </div>
    </div>
  </form>

  <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12 margin-top-2">
    @if (gridOptions) {
      <ag-grid-angular style="height: 600px;" class="ag-theme-alpine" [gridOptions]="gridOptions"
        [rowData]="rowData"
        [columnDefs]="frtTspRatingColumnDefs"
        [enableRangeSelection]="true">
      </ag-grid-angular>
    }
  </div>
</div>
